/* eslint-disable react/prop-types */
import React, { useEffect, useState } from "react";
import { Box, Grid, Typography } from "@mui/material";
import FormField from "components/FormField";
import Footer from "./footer";
import SoftButton from "components/SoftButton";
import SoftBox from "components/SoftBox";

const tableStyle = {
  borderCollapse: "collapse",
  width: "100%",
  fontSize: "14px",
};

const thTdStyle = {
  border: "1px solid black",
  textAlign: "left",
  padding: "8px",
  fontWeight: 400,
};

const Th = ({ children, style, ...rest }) => {
  return (
    <th {...rest} style={{ ...thTdStyle, ...style }}>
      {children}
    </th>
  );
};
const Td = ({ children, style, row, ...rest }) => {
  return (
    <th {...rest} style={{ ...thTdStyle, ...style }}>
      {children}
    </th>
  );
};

const dataTable = [
  { id: 0, value: { priceNoVat: 0, priceVat: 0, vat: 0 } },
  { id: 1, value: { priceNoVat: 0, priceVat: 0, vat: 0 } },
  { id: 2, value: { priceNoVat: 0, priceVat: 0, vat: 0 } },
  { id: 3, value: { priceNoVat: 0, priceVat: 0, vat: 0 } },
  { id: 4, value: { priceNoVat: 0, priceVat: 0, vat: 0 } },
];

const dataTableB = [{ id: 1, value: { income: "", priceNoVat: 0, priceVat: 0, vat: 0 } }];

export default function TaxPersonalTable({ formData, setFieldValue }) {
  const [data, setData] = useState(dataTable);
  const [dataB, setDataB] = useState(dataTableB);

  useEffect(() => {
    setFieldValue("valuesTable", data);
    setFieldValue("valuesTableB", dataB);
  }, [data, dataB]);

  const handleChange = (values) => {
    const { id, name, value } = values;
    setData((prev) =>
      prev.map((item) => {
        if (item.id === id) {
          return { ...item, value: { ...item.value, [name]: value } };
        }
        return item;
      })
    );
    console.log(data);
  };

  const handleChangeB = (values) => {
    const { id, name, value } = values;
    setDataB((prev) =>
      prev.map((item) => {
        if (item.id === id) {
          return { ...item, value: { ...item.value, [name]: value } };
        }
        return item;
      })
    );
    console.log(dataB);
  };

  const addNewRow = () => {
    const newIdValue = dataB.length + 1;
    const newRow = {
      id: newIdValue,
      value: { income: "", priceNoVat: 0, priceVat: 0, vat: 0 },
    };
    setDataB((prev) => [...prev, newRow]);
  };

  const removeRow = () => {
    if (dataB.length !== 1) {
      dataB.pop();
      const newRow = dataB;
      setDataB([...newRow]);
    }
  };

  return (
    <Box display="flex" flexDirection="column" mt={5}>
      <Box display="flex" justifyContent="flex-start">
        <Typography fontWeight="bold" variant="h6" fontSize={14}>
          A. Khai thuế theo phương pháp trực tiếp trên doanh thu:
        </Typography>
      </Box>
      <Box display="flex" justifyContent="flex-end">
        <Typography variant="subtitle1" fontSize={14} fontStyle="italic">
          Đơn vị tiền: Đồng Việt Nam
        </Typography>
      </Box>
      <Box>
        <table style={tableStyle}>
          <thead>
            <tr>
              <Th style={{ textAlign: "center", width: "5%" }}>STT</Th>
              <Th style={{ textAlign: "center", width: "35%" }}>Nhóm ngành</Th>
              <Th style={{ textAlign: "center", width: "20%" }} colSpan={2}>
                Doanh thu chịu thuế suất 0% và không chịu thuế
              </Th>
              <Th style={{ textAlign: "center", width: "20%" }} colSpan={2}>
                Doanh thu chịu thuế giá trị gia tăng (trừ thuế suất 0%)
              </Th>
              <Th style={{ textAlign: "center", width: "20%" }} colSpan={2}>
                Thuế giá trị gia tăng phải nộp
              </Th>
            </tr>
            <tr>
              <Th style={{ textAlign: "center" }}>(1)</Th>
              <Th style={{ textAlign: "center" }}>(2)</Th>
              <Th style={{ textAlign: "center" }} colSpan={2}>
                (3)
              </Th>
              <Th style={{ textAlign: "center" }} colSpan={2}>
                (4)
              </Th>
              <Th style={{ textAlign: "center" }} colSpan={2}>
                (5)
              </Th>
            </tr>
          </thead>
          <tbody>
            <tr key={0}>
              <Td
                style={{
                  textAlign: "center",
                  background: "transparent",
                  fontWeight: 400,
                }}
              >
                {"1"}
              </Td>
              <Td
                colSpan={1}
                style={{
                  textAlign: "left",
                  background: "transparent",
                  fontWeight: 400,
                }}
              >
                {"Phân phối, cung cấp hàng hóa ([23]=[22]x1%)"}
              </Td>
              <Td
                colSpan={1}
                rowSpan={4}
                style={{
                  textAlign: "left",
                  background: "transparent",
                  fontWeight: 400,
                }}
              >
                {"[21]"}
              </Td>
              <Td
                colSpan={1}
                rowSpan={4}
                style={{
                  textAlign: "right",
                  background: "transparent",
                }}
              >
                <InputTable
                  id={0}
                  name="priceNoVat"
                  value={data[0].value.priceNoVat}
                  onChange={handleChange}
                />
              </Td>
              <Td
                colSpan={1}
                style={{
                  textAlign: "left",
                  background: "transparent",
                  fontWeight: 400,
                }}
              >
                {"[22]"}
              </Td>
              <Td
                colSpan={1}
                style={{
                  textAlign: "right",
                  background: "transparent",
                }}
              >
                <InputTable
                  id={0}
                  name="priceVat"
                  value={data[0].value.priceVat}
                  onChange={handleChange}
                />
              </Td>
              <Td
                colSpan={1}
                style={{
                  textAlign: "left",
                  background: "#ddeff3",
                  fontWeight: 400,
                }}
              >
                {"[23]"}
              </Td>
              <Td
                colSpan={1}
                style={{
                  textAlign: "right",
                  background: "#ddeff3",
                }}
              >
                <InputTable
                  id={0}
                  name="vat"
                  readonly="true"
                  value={data[0].value.vat}
                  onChange={handleChange}
                  fontWeight={true}
                />
              </Td>
            </tr>
            <tr key={1}>
              <Td
                style={{
                  textAlign: "center",
                  background: "transparent",
                  fontWeight: 400,
                }}
              >
                {"2"}
              </Td>
              <Td
                colSpan={1}
                style={{
                  textAlign: "left",
                  background: "transparent",
                  fontWeight: 400,
                }}
              >
                {"Dịch vụ, xây dựng không bao thầu nguyên vật liệu ([25]=[24]x5%)"}
              </Td>
              <Td
                colSpan={1}
                style={{
                  textAlign: "left",
                  background: "transparent",
                  fontWeight: 400,
                }}
              >
                {"[24]"}
              </Td>
              <Td
                colSpan={1}
                style={{
                  textAlign: "right",
                  background: "transparent",
                }}
              >
                <InputTable
                  id={1}
                  name="priceVat"
                  value={data[1].value.priceVat}
                  onChange={handleChange}
                />
              </Td>
              <Td
                colSpan={1}
                style={{
                  textAlign: "left",
                  background: "#ddeff3",
                  fontWeight: 400,
                }}
              >
                {"[25]"}
              </Td>
              <Td
                colSpan={1}
                style={{
                  textAlign: "right",
                  background: "#ddeff3",
                }}
              >
                <InputTable
                  id={1}
                  name="vat"
                  readonly="true"
                  value={data[1].value.vat}
                  onChange={handleChange}
                  fontWeight={true}
                />
              </Td>
            </tr>
            <tr key={2}>
              <Td
                style={{
                  textAlign: "center",
                  background: "transparent",
                  fontWeight: 400,
                }}
              >
                {"3"}
              </Td>
              <Td
                colSpan={1}
                style={{
                  textAlign: "left",
                  background: "transparent",
                  fontWeight: 400,
                }}
              >
                {
                  "Sản xuất, vận tải, dịch vụ có gắn với hàng hóa, xây dựng có bao thầu nguyên vật liệu ([27]=[26]x3%)"
                }
              </Td>
              <Td
                colSpan={1}
                style={{
                  textAlign: "left",
                  background: "transparent",
                  fontWeight: 400,
                }}
              >
                {"[26]"}
              </Td>
              <Td
                colSpan={1}
                style={{
                  textAlign: "right",
                  background: "transparent",
                }}
              >
                <InputTable
                  id={2}
                  name="priceVat"
                  value={data[2].value.priceVat}
                  onChange={handleChange}
                />
              </Td>
              <Td
                colSpan={1}
                style={{
                  textAlign: "left",
                  background: "#ddeff3",
                  fontWeight: 400,
                }}
              >
                {"[27]"}
              </Td>
              <Td
                colSpan={1}
                style={{
                  textAlign: "right",
                  background: "#ddeff3",
                }}
              >
                <InputTable
                  id={2}
                  name="vat"
                  readonly="true"
                  value={data[2].value.vat}
                  onChange={handleChange}
                  fontWeight={true}
                />
              </Td>
            </tr>
            <tr key={3}>
              <Td
                style={{
                  textAlign: "center",
                  background: "transparent",
                  fontWeight: 400,
                }}
              >
                {"4"}
              </Td>
              <Td
                colSpan={1}
                style={{
                  textAlign: "left",
                  background: "transparent",
                  fontWeight: 400,
                }}
              >
                {"Hoạt động kinh doanh khác ([29]=[28]x2%)"}
              </Td>
              <Td
                colSpan={1}
                style={{
                  textAlign: "left",
                  background: "transparent",
                  fontWeight: 400,
                }}
              >
                {"[28]"}
              </Td>
              <Td
                colSpan={1}
                style={{
                  textAlign: "right",
                  background: "transparent",
                }}
              >
                <InputTable
                  id={3}
                  name="priceVat"
                  value={data[3].value.priceVat}
                  onChange={handleChange}
                />
              </Td>
              <Td
                colSpan={1}
                style={{
                  textAlign: "left",
                  background: "#ddeff3",
                  fontWeight: 400,
                }}
              >
                {"[29]"}
              </Td>
              <Td
                colSpan={1}
                style={{
                  textAlign: "right",
                  background: "#ddeff3",
                }}
              >
                <InputTable
                  id={3}
                  name="vat"
                  readonly="true"
                  value={data[3].value.vat}
                  onChange={handleChange}
                  fontWeight={true}
                />
              </Td>
            </tr>
            <tr key={4}>
              <Td
                style={{
                  textAlign: "center",
                  background: "#ddeff3",
                  fontWeight: "bold",
                }}
              >
                {"5"}
              </Td>
              <Td
                colSpan={1}
                style={{
                  textAlign: "left",
                  background: "#ddeff3",
                  fontWeight: "bold",
                }}
              >
                {
                  "Doanh thu và số thuế phải nộp ([30]=[22]+[24]+[26]+[28];[31]=[23]+[25]+[27]+[29])"
                }
              </Td>
              <Td
                colSpan={2}
                style={{
                  textAlign: "left",
                  background: "#ddeff3",
                  fontWeight: "bold",
                }}
              ></Td>
              <Td
                colSpan={1}
                style={{
                  textAlign: "left",
                  background: "#ddeff3",
                  fontWeight: 400,
                }}
              >
                {"[30]"}
              </Td>
              <Td
                colSpan={1}
                style={{
                  textAlign: "right",
                  background: "#ddeff3",
                  fontWeight: 400,
                }}
              >
                <InputTable
                  id={4}
                  name="priceVat"
                  readonly="true"
                  value={data[4].value.priceVat}
                  onChange={handleChange}
                  fontWeight={true}
                />
              </Td>
              <Td
                colSpan={1}
                style={{
                  textAlign: "left",
                  background: "#ddeff3",
                  fontWeight: 400,
                }}
              >
                {"[31]"}
              </Td>
              <Td
                colSpan={1}
                style={{
                  textAlign: "right",
                  background: "#ddeff3",
                }}
              >
                <InputTable
                  id={4}
                  name="vat"
                  readonly="true"
                  value={data[4].value.vat}
                  onChange={handleChange}
                  fontWeight={true}
                />
              </Td>
            </tr>
          </tbody>
        </table>
        <Box display="flex">
          <Typography
            fontWeight="bold"
            variant="h6"
            fontSize={14}
            textAlign="left"
            minWidth={250}
            marginTop={1.5}
          >
            Tổng doanh thu ([32]=[21]+[30])
          </Typography>
          <Typography
            fontWeight="bold"
            variant="h6"
            fontSize={14}
            textAlign="right"
            width={"100%"}
            marginTop={1}
          >
            <InputTable2
              id={4}
              name="total"
              value={0}
              fontWeight={true}
              // onChange={handleChange}
            />
          </Typography>

          <Typography
            fontWeight="bold"
            variant="h6"
            fontSize={14}
            textAlign="right"
            minWidth={100}
            marginTop={1.5}
          >
            Đồng Việt Nam
          </Typography>
        </Box>
        <Box display="flex" justifyContent="flex-start" marginTop={2}>
          <Typography fontWeight="bold" variant="h6" fontSize={14}>
            B. Khai riêng đối với khoản thu hộ do cơ quan nhà nước có thẩm quyền giao:
          </Typography>
        </Box>
        <Box>
          <table style={tableStyle}>
            <thead>
              <tr>
                <Th style={{ textAlign: "center", width: "5%" }}>STT</Th>
                <Th style={{ textAlign: "center", width: "35%" }}>Khoản thu hộ</Th>
                <Th style={{ textAlign: "center", width: "20%" }}>
                  Doanh thu chưa có thuế giá trị gia tăng
                </Th>
                <Th style={{ textAlign: "center", width: "20%" }}>Thuế suất</Th>
                <Th style={{ textAlign: "center", width: "20%" }}>
                  Thuế giá trị gia tăng phải nộp
                </Th>
              </tr>
              <tr>
                <Th style={{ textAlign: "center" }}>(1)</Th>
                <Th style={{ textAlign: "center" }}>(2)</Th>
                <Th style={{ textAlign: "center" }}>[33]</Th>
                <Th style={{ textAlign: "center" }}>[34]</Th>
                <Th style={{ textAlign: "center" }}>[35]=[33]x[34]</Th>
              </tr>
            </thead>
            <tbody>
              {dataB &&
                dataB.length > 0 &&
                dataB.map((rows) => (
                  <tr key={rows.id}>
                    <Td
                      style={{
                        textAlign: "center",
                        background: "transparent",
                        fontWeight: 400,
                      }}
                    >
                      {rows.id}
                    </Td>
                    <Td
                      colSpan={1}
                      style={{
                        textAlign: "left",
                        background: "transparent",
                        fontWeight: 400,
                      }}
                    >
                      {/* {chưa nhận giá trị} */}
                      <InputTable3
                        id={rows.id}
                        name="income"
                        value={rows.value.income}
                        onChange={handleChangeB}
                      />
                    </Td>
                    <Td
                      colSpan={1}
                      style={{
                        textAlign: "right",
                        background: "transparent",
                      }}
                    >
                      <InputTable
                        id={rows.id}
                        name="priceNoVat"
                        value={rows.value.priceNoVat}
                        onChange={handleChangeB}
                      />
                    </Td>
                    <Td
                      colSpan={1}
                      style={{
                        textAlign: "right",
                        background: "#ddeff3",
                      }}
                    >
                      <InputTable
                        id={0}
                        name="priceNoVat"
                        readonly="true"
                        value={dataB[0].value.priceNoVat}
                        onChange={handleChangeB}
                        fontWeight={true}
                      />
                    </Td>
                    <Td
                      colSpan={1}
                      style={{
                        textAlign: "right",
                        background: "#ddeff3",
                      }}
                    >
                      <InputTable
                        id={0}
                        name="priceNoVat"
                        readonly="true"
                        value={dataB[0].value.priceNoVat}
                        onChange={handleChangeB}
                        fontWeight={true}
                      />
                    </Td>
                  </tr>
                ))}

              <tr key={1}>
                <Td
                  style={{
                    textAlign: "center",
                    background: "#ddeff3",
                    fontWeight: "bold",
                  }}
                ></Td>
                <Td
                  colSpan={1}
                  style={{
                    textAlign: "left",
                    background: "#ddeff3",
                    fontWeight: "bold",
                  }}
                >
                  {"Doanh thu và số thuế phải nộp ([36]=Σ[33];[37]=Σ[35])"}
                </Td>
                <Td
                  colSpan={1}
                  style={{
                    textAlign: "right",
                    background: "#ddeff3",
                    fontWeight: "bold",
                  }}
                >
                  <InputTable
                    id={0}
                    name="priceNoVat"
                    readonly="true"
                    value={data[0].value.priceNoVat}
                    onChange={handleChangeB}
                    fontWeight={true}
                  />
                </Td>
                <Td
                  colSpan={1}
                  style={{
                    textAlign: "right",
                    background: "#ddeff3",
                  }}
                ></Td>
                <Td
                  colSpan={1}
                  style={{
                    textAlign: "right",
                    background: "#ddeff3",
                    fontWeight: "bold",
                  }}
                >
                  <InputTable
                    id={0}
                    name="priceNoVat"
                    readonly="true"
                    value={data[0].value.priceNoVat}
                    onChange={handleChangeB}
                    fontWeight={true}
                  />
                </Td>
              </tr>
            </tbody>
          </table>
        </Box>
        <SoftBox display="flex" justifyContent="flex-start" gap={3} mt={2}>
          <SoftButton variant="gradient" color="dark" onClick={addNewRow}>
            Thêm dòng
          </SoftButton>
          <SoftButton variant="gradient" color="light" onClick={removeRow}>
            Xóa dòng
          </SoftButton>
        </SoftBox>
        <Footer formData={formData} />
      </Box>
    </Box>
  );
}

function InputTable(props) {
  const { id, onChange, fontWeight, ...rest } = props;
  const regexNumber = /^(0|[1-9]\d*)?$/;

  function handleChange(event) {
    const { name, value } = event.target;
    const newValue = value === "0" ? "" : value;
    if (!regexNumber.test(newValue)) return;
    onChange({ id, value: newValue !== "" ? +newValue : "", name });
  }
  return (
    <input
      type="text"
      style={{
        textAlign: "right",
        fontSize: "14px",
        color: "#344767",
        border: "none",
        background: "transparent",
        padding: "4px 4px 4px 4px",
        width: "100%",
        fontWeight: fontWeight && fontWeight === true ? "bold" : 400,
      }}
      onChange={handleChange}
      {...rest}
    />
  );
}
function InputTable2(props) {
  const { id, onChange, fontWeight, ...rest } = props;
  const regexNumber = /^(0|[1-9]\d*)?$/;

  function handleChange(event) {
    const { name, value } = event.target;
    const newValue = value === "0" ? "" : value;
    if (!regexNumber.test(newValue)) return;
    onChange({ id, value: newValue !== "" ? +newValue : "", name });
  }
  return (
    <input
      type="text"
      style={{
        textAlign: "right",
        fontSize: "14px",
        color: "#344767",
        border: "none",
        background: "transparent",
        padding: "4px 4px 4px 4px",
        width: "30%",
        minWidth: 100,
        border: "1px solid black",
        fontWeight: fontWeight && fontWeight === true ? "bold" : 400,
      }}
      onChange={handleChange}
      {...rest}
    />
  );
}
function InputTable3(props) {
  const { id, onChange, type, ...rest } = props;
  const regexNumber = /^(0|[1-9]\d*)?$/;
  const regexDecimal = /^(0|0?\.\d*|1|1(\.0*)?)?$/;

  function handleChange(event) {
    const { name, value } = event.target;
    const newValue = value;
    if (type == "number") {
      if (!regexNumber.test(newValue)) return;
      onChange({ id, value: newValue !== "" ? +newValue : "", name });
    } else if (type == "decimal") {
      if (!regexDecimal.test(newValue)) return;
      onChange({ id, value: newValue, name });
    } else {
      onChange({ id, value: newValue !== "" ? newValue : "", name });
    }
  }
  return (
    <input
      type={type == "date" ? "date" : ""}
      style={{
        textAlign: type == "number" || type == "decimal" ? "right" : "left",
        fontSize: "14px",
        color: "#344767",
        border: "none",
        width: type == "date" ? "150px" : "100%",
        background: "transparent",
        padding: "4px 4px 4px 4px",
      }}
      onChange={handleChange}
      {...rest}
    />
  );
}
